import React from 'react';
import ExpiredSubscriptionOverlay from '../SubscriptionFeatureGuard/ExpiredSubscriptionOverlay';
import { SubscriptionLockCode, SubscriptionLockDetails } from '../../utility/subscriptionLock';

export interface SubscriptionLockScreenProps {
  code: SubscriptionLockCode | null;
  /** Server-supplied message. The card uses the portal's own translated copy instead. */
  message?: string | null;
  details?: SubscriptionLockDetails | null;
  /** Whether this user is allowed to settle the bill. */
  canManageBilling: boolean;
}

/**
 * Full-page lockout screen (CVA-4668).
 *
 * Reuses the existing restricted-service card, rendered INSTEAD OF the route
 * rather than on top of it — the previous overlay left the real page mounted
 * underneath, so its data still loaded and was readable through the blur.
 *
 * A user who can pay gets a button to billing. A user who cannot gets a
 * read-only "contact your administrator" message — no redirect, which is what
 * caused the loop in CVA-3661.
 */
const SubscriptionLockScreen: React.FC<SubscriptionLockScreenProps> = ({
  code,
  details,
  canManageBilling,
}) => (
  <div
    data-testid="subscription-lock-screen"
    data-lock-code={code ?? ''}
    data-can-manage-billing={String(canManageBilling)}
  >
    <ExpiredSubscriptionOverlay
      inline
      code={code}
      canManageBilling={canManageBilling}
      unpaidInvoiceCount={details?.unpaidInvoiceCount ?? 0}
      outstandingAmount={details?.outstandingAmount ?? 0}
    />
  </div>
);

export default SubscriptionLockScreen;
